import type { Coupon } from '@/domains/productDiscovery/ProductPage/interfaces/Detail.common.model';

export const getBestCoupon = (coupons?: Coupon[]): Coupon | undefined => {
  if (!coupons || coupons.length === 0) return undefined;
  return coupons.reduce((prev, curr) =>
    +prev.amount >= +curr.amount ? prev : curr,
  );
};
